import * as XLSX from 'xlsx';

const RECEIVER = {
  company:  'Identium tech solutions Private Limited',
  contact:  'Adhish Parasa',
  gstin:    '07AAGCI6275E1ZH',
  iec:      'AAGCI6275E',
  ad_code:  '0181391',
  address:  'BACK PORTION, FIRST FLOOR, PROPERTY BEARING NO.5,  SANT NAGAR, EAST OF KAILASH,',
  city:     'New Delhi,India',
  country:  'India',
  zip:      '110065',
  phone:    '+91-7827944632',
};
const FWD_LABEL = { fedex_india: 'FedEx India A/C — 651730414', yitong_jimmy: 'Yitong / Jimmy', fedex_china: 'FedEx China', self: 'Self', other: 'Other' };

/**
 * Build an .xlsx that matches the reference Inuni_700.xls layout.
 *  - 7 columns wide (A..G)
 *  - 38 merged ranges per row template
 *  - Column widths and row heights match the original
 */
export function buildShippingInvoiceXLSX(si, items) {
  const ws = {};
  // Use AOA-style cell-by-cell writes so we can attach merges + styles
  const set = (addr, value, type) => {
    ws[addr] = { v: value == null ? '' : value, t: type || (typeof value === 'number' ? 'n' : 's') };
  };

  const fromCity    = si.sender_city || si.supplier_city || '';
  const fromAddr    = si.sender_address || si.supplier_address || '';
  const fromTel     = si.sender_phone || '';
  const fromCountry = si.sender_country || si.supplier_country || 'China';
  const fromZip     = si.sender_zip || '';

  // ── Row 1: COMMERCIAL INVOICE title (A1:G1) ──────────────────────────
  set('A1', 'COMMERCIAL INVOICE');
  // ── Row 2: 商业发票 (A2:G2) ───────────────────────────────────────────
  set('A2', '商业发票');
  // ── Row 3: Date | Invoice No  (A3:C3 + D3:G3) ─────────────────────────
  set('A3', `Date日期:    ${si.ship_date}`);
  set('D3', si.po_number
    ? `Invoice No: ${si.invoice_number}   ||   PO NO.: ${si.po_number}`
    : `Invoice No: ${si.invoice_number}`);
  // ── Row 4: FROM | TO headers (A4:C4 + D4:G4) ──────────────────────────
  set('A4', 'FROM:  (Collection Address 寄件方)');
  set('D4', 'TO:  (Receiver 收件方)');
  // ── Row 5: company name (B5:C5 value-L, E5:G5 value-R) ────────────────
  set('A5', 'company name:\n（公司）');
  set('B5', si.beneficiary_name);
  set('D5', 'company name:\n（公司）');
  set('E5', RECEIVER.company);
  // ── Row 6: Contact name ──────────────────────────────────────────────
  set('A6', 'Contact Name:\n（联系人姓名）');
  set('B6', si.sender_contact_name || si.supplier_default_contact || '');
  set('D6', 'Contact Name:\n（联系人姓名）');
  set('E6', RECEIVER.contact);
  // ── Row 7: Address-L (merged A7:A8 + B7:C8) + KYC-R ──────────────────
  set('A7', 'Address:\n（地址）');
  set('B7', fromAddr);
  set('D7', 'KYC：');
  set('E7', `GSTIN : ${RECEIVER.gstin} | IEC:${RECEIVER.iec} | AdCode: ${RECEIVER.ad_code}`);
  // ── Row 8: Address-R ─────────────────────────────────────────────────
  set('D8', 'Address:\n（地址）');
  set('E8', RECEIVER.address);
  // ── Row 9: City ──────────────────────────────────────────────────────
  set('A9', 'City（城市）');
  set('B9', fromCity);
  set('D9', 'City(城市)');
  set('E9', RECEIVER.city);
  // ── Row 10: Tel ──────────────────────────────────────────────────────
  set('A10', 'Tel No:（电话）');
  set('B10', fromTel);
  set('D10', 'Tel No:（电话）');
  set('E10', si.receiver_phone || RECEIVER.phone);
  // ── Row 11: Country ──────────────────────────────────────────────────
  set('A11', 'Country of\nExport\n（出口国）');
  set('B11', fromCountry);
  set('D11', 'Country of\ndestination\n（进口国）');
  set('E11', RECEIVER.country);
  // ── Row 12: zip ──────────────────────────────────────────────────────
  set('A12', 'zip code\n（邮政编码）');
  set('B12', fromZip, 'n');
  set('D12', 'zip code\n(邮政编码)');
  set('E12', RECEIVER.zip);
  // ── Row 13: Items table header ───────────────────────────────────────
  set('A13', 'DESCRIPTION\nOF GOODS');  // A13:B13 visual
  set('C13', 'HSN Code');
  set('D13', 'Qty');                    // D13:E13
  set('F13', 'Unit Price');
  set('G13', 'VALUE');
  // ── Items rows 14+ ───────────────────────────────────────────────────
  let r = 14;
  items.forEach((it) => {
    set(`A${r}`, it.description);
    set(`C${r}`, it.hsn_code || '', 'n');
    set(`D${r}`, parseFloat(it.quantity), 'n');
    set(`F${r}`, parseFloat(it.unit_price), 'n');
    set(`G${r}`, parseFloat(it.amount), 'n');
    r++;
  });

  // ── Freight row ──────────────────────────────────────────────────────
  const freightR = r;
  set(`A${freightR}`, 'Freight（运费）   ');     // A:F merged
  set(`G${freightR}`, si.freight_value != null ? parseFloat(si.freight_value) : (si.freight_terms || 'FOB'),
      si.freight_value != null ? 'n' : 's');
  r++;

  // ── Total row ────────────────────────────────────────────────────────
  const totalR = r;
  set(`A${totalR}`, `    合计（${si.currency || 'USD'}）TOTAL：`); // A:F merged
  set(`G${totalR}`, parseFloat(si.total_value), 'n');
  r++;

  // ── Certification row (full width merged) ───────────────────────────
  const certR = r;
  set(`A${certR}`,
    'I hereby certify the information on this declaration is true and correct to the best of my knowledge，' +
    ' and that the contents of this shipment are as stated above。\n' +
    '本人仅此证明以上所申报属实。');
  r++;
  // ── Forwarder info row (full width merged) ─────────────────────────
  const fwdR = r;
  // Forwarder intentionally NOT printed (internal only)
  const fwdLines = [];
  if (si.fedex_account)  fwdLines.push(`FedEx Account: ${si.fedex_account}`);
  if (si.fedex_awb)      fwdLines.push(`FedEx AWB: ${si.fedex_awb}`);
  set(`A${fwdR}`, fwdLines.join('   |   '));
  r++;
  // ── Signature row 1 ────────────────────────────────────────────────
  const sig1R = r;
  set(`A${sig1R}`, 'SIGNATURE：');
  r++;
  // ── Signature row 2 (chop + date) ──────────────────────────────────
  const sig2R = r;
  set(`A${sig2R}`, '寄件人签名（盖章）');
  set(`F${sig2R}`, `日期：  ${si.ship_date}`);
  r++;

  // Range
  ws['!ref'] = `A1:G${r - 1}`;

  // ── Merges ────────────────────────────────────────────────────────
  const M = (s, e) => ({ s: XLSX.utils.decode_cell(s), e: XLSX.utils.decode_cell(e) });
  const merges = [
    M('A1', 'G1'), M('A2', 'G2'),
    M('A3', 'C3'), M('D3', 'G3'),
    M('A4', 'C4'), M('D4', 'G4'),
    M('B5', 'C5'), M('E5', 'G5'),
    M('B6', 'C6'), M('E6', 'G6'),
    M('A7', 'A8'), M('B7', 'C8'),
    M('E7', 'G7'),
    M('E8', 'G8'),
    M('B9', 'C9'), M('E9', 'G9'),
    M('B10','C10'),M('E10','G10'),
    M('B11','C11'),M('E11','G11'),
    M('B12','C12'),M('E12','G12'),
    M('A13','B13'),M('D13','E13'),
  ];
  // Items: merge A:B for each item row
  for (let i = 14; i < freightR; i++) {
    merges.push(M(`A${i}`, `B${i}`));
    merges.push(M(`D${i}`, `E${i}`));
  }
  merges.push(M(`A${freightR}`, `F${freightR}`));
  merges.push(M(`A${totalR}`,   `F${totalR}`));
  merges.push(M(`A${certR}`,    `G${certR}`));
  merges.push(M(`A${fwdR}`,     `G${fwdR}`));
  merges.push(M(`A${sig1R}`,    `B${sig1R}`));
  merges.push(M(`A${sig2R}`,    `B${sig2R}`));
  ws['!merges'] = merges;

  // ── Column widths (in characters) — A..G ─────────────────────────
  ws['!cols'] = [
    { wch: 18 },  // A — labels
    { wch: 14 },  // B — value left part 1
    { wch: 18 },  // C — HSN code
    { wch: 14 },  // D — label right
    { wch: 16 },  // E — value right part 1
    { wch: 14 },  // F — Unit Price
    { wch: 12 },  // G — Value
  ];

  // ── Row heights (px) — approximate Excel original ────────────────
  const rowH = [
    38, 18, 22.5, 28, 48, 35, 35, 91, 25, 30, 46, 32.25, 31,
  ];
  ws['!rows'] = rowH.map(h => ({ hpx: h }));
  // Item rows
  for (let i = 14; i < freightR; i++)  ws['!rows'][i - 1] = { hpx: 42 };
  ws['!rows'][freightR - 1] = { hpx: 35 };
  ws['!rows'][totalR   - 1] = { hpx: 30 };
  ws['!rows'][certR    - 1] = { hpx: 69 };
  ws['!rows'][fwdR     - 1] = { hpx: 25 };
  ws['!rows'][sig1R    - 1] = { hpx: 30 };
  ws['!rows'][sig2R    - 1] = { hpx: 30 };

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Shipping Invoice');
  XLSX.writeFile(wb, `ShippingInvoice-${si.invoice_number.replace(/\//g, '-')}.xlsx`);
}
